import script from "./FormularioModeloVehiculo.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormularioModeloVehiculo.vue?vue&type=script&setup=true&lang=ts"

import "./FormularioModeloVehiculo.vue?vue&type=style&index=0&id=7a027710&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a027710"]])

export default __exports__